import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { AuthService } from '../services/auth.service';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {NgIf} from "@angular/common";
import {SuccessDialogComponent} from "../services/success-dialog.component";
import {FailureDialogComponent} from "../services/failure-dialog.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgIf,
        MatDialogModule
    ],
    styleUrls: ['./login.component.scss']
})
export class LoginComponent {
    loginForm: FormGroup;
    @Output() registerClicked = new EventEmitter<void>();
    @Input() doLogin!: boolean;
    isPlacingOrder = false;


    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private dialog: MatDialog
    ) {
        this.loginForm = this.fb.group({
            identifier: ['', Validators.required], // email/mobile instead of username
            password: ['', Validators.required]
        });
    }
    showPassword = false;

    togglePassword() {
        this.showPassword = !this.showPassword;
    }

    onLogin() {
        if (this.loginForm.valid) {
            this.authService.login(this.loginForm.value).subscribe({
                next: (res) => {
                    const dialogRef = this.dialog.open(SuccessDialogComponent,{
                        data: { title: 'Login Successful',message : res.message}
                    });
                    this.authService.setName(res.name);
                    this.authService.setRole(res.role);
                    this.authService.setToken(res.accessToken);
                    this.authService.setUserId(res.userId);
                    dialogRef.afterClosed().subscribe(() => {
                        window.location.reload(); // redirect after success
                    });
                },
                error: (err) => {
                    const dialogRef = this.dialog.open(FailureDialogComponent, {
                        data: { message: err.error?.message || 'Invalid credentials' }
                    });
                    dialogRef.afterClosed().subscribe(() => {
                        console.error('Login failed:', err.error?.message || err.message);
                    });
                }
            });
        }
    }

    onRegister() {
        this.registerClicked.emit();
    }
}